import { AvvirEvent } from "type_aliases";

export const PROCORE_LOCATIONS_LOADED = 'procore_locations_loaded';

export type ProcoreLocationsLoadedEvent = AvvirEvent<typeof PROCORE_LOCATIONS_LOADED, any>;

const procoreLocationsLoaded = (procoreLocations: any): ProcoreLocationsLoadedEvent => ({
  type: PROCORE_LOCATIONS_LOADED,
  payload: procoreLocations
});

export default procoreLocationsLoaded;